import React, { useState, useEffect } from "react";
import { Button, SIZE as BSIZE } from "baseui/button";
import { ButtonGroup, MODE } from "baseui/button-group";
import { Input, SIZE as ISIZE } from "baseui/input";
import Search from "baseui/icon/search";
import { Select } from "baseui/select";
import { styled } from "baseui";
import { FaList, FaTh, FaRedo } from "react-icons/fa";
import { useStyletron } from "baseui";
import useRouteParams from "../../hooks/useRouteParams";

const GridContainer = styled("div", ({ $theme }) => ({
  display: "flex",
  alignItems: "center",
}));

const GridItem = styled("div", ({ $theme }) => ({
  margin: "0px 10px",
}));

const SearchInputContainer = styled("div", ({ $theme }) => ({
  width: "300px",
}));

const SelectContainer = styled("div", {
  width: "150px",
});

const TIME_OPTIONS = [
  { label: "All Time", id: "all" },
  { label: "Last Week", id: "week" },
  { label: "Last Month", id: "month" },
  { label: "Last Year", id: "year" },
];
const VIEW_MODES = {
  list: 0,
  grid: 1,
  // card: 2
};

function ListSearchGroup({
  onViewModeChange,
  onTimeKeywordSearchChange,
  onRetryFetch,
}) {
  const [viewMode, setViewMode] = useState("list");
  const [css, theme] = useStyletron();
  const { searchParams } = useRouteParams();
  const [searchValue, setSearchValue] = useState(searchParams["q"] || "");
  const [selectedTime, setSelectedTime] = useState(TIME_OPTIONS.find((item) => item.id === searchParams["time"]) || TIME_OPTIONS[0]);
  
  useEffect(() => {
    setSearchValue(searchParams["q"] || "");
    setSelectedTime(TIME_OPTIONS.find((item) => item.id === searchParams["time"]) || TIME_OPTIONS[0]);
  }, [searchParams["q"], searchParams["time"]]);

  const handleSearchChange = (time) => {
    const queryStringParts = [];
    if (searchValue.trim() !== "") {
      queryStringParts.push(`q=${encodeURIComponent(searchValue)}`);
    }
    queryStringParts.push(`time=${time?.id ? time.id : selectedTime.id}`);
    const queryString = queryStringParts.join('&');
    
    onTimeKeywordSearchChange(queryString);
  }

  return (
    <GridContainer>
      <GridItem>
        <Button
          size={BSIZE.compact}
          aria-label="Refresh"
          onClick={onRetryFetch}
          kind="minimal"
        >
          <FaRedo />
        </Button>
      </GridItem>
      <GridItem>
        <SearchInputContainer>
          <Input
            size={ISIZE.mini}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearchChange()}
            startEnhancer={() => (
              <Button
                size={BSIZE.mini}
                aria-label="Search"
                onClick={()=>handleSearchChange()}
                kind="minimal"
              >
                <Search size={18} />
              </Button>
            )}
            clearable
            clearOnEscape
            placeholder="Search templates"
          />
        </SearchInputContainer>
      </GridItem>
      <GridItem>
        <SelectContainer>
          <Select
            size={ISIZE.compact}
            options={TIME_OPTIONS}
            searchable={false}
            clearable={false}
            value={[selectedTime]}
            onChange={(params) => {
              handleSearchChange(params.value[0]);
            }}            
            mapOptionToString={(option) => option.label}
            aria-label="Time Filter"
          />
        </SelectContainer>
      </GridItem>
      <GridItem>
        <ButtonGroup
          mode={MODE.radio}
          // selected={selectedButton}
          size={BSIZE.compact}
          onClick={(event, index) => {
            const mode = Object.keys(VIEW_MODES).find(
              (key) => VIEW_MODES[key] === index
            );
            setViewMode(mode);
            // Inform the parent about the change in the view mode
            onViewModeChange && onViewModeChange(mode);
          }}
        >
          <Button aria-label="Switch to List View">
            <FaList
              color={
                viewMode === "list" ? theme.colors.accent400 : "currentColor"
              }
            />
          </Button>
          <Button aria-label="Switch to Grid View">
            <FaTh
              color={
                viewMode === "grid" ? theme.colors.accent400 : "currentColor"
              }
            />
          </Button>
          {/* <Button aria-label="Switch to Card View">
            <FaThLarge color={viewMode === 'card' ? theme.colors.accent400 : "currentColor"} />
          </Button> */}
        </ButtonGroup>
      </GridItem>

    </GridContainer>
  );
}

export default ListSearchGroup;
